export default __webpack_public_path__ + "static/media/web-logo-teszt-5.32aba4da.svg";